import { z } from "zod";
/**
 * Solicitação de correção de campo ERP feita pelo colaborador (FASE-06-T33).
 * Vira uma `Request` endereçada ao RH — não altera o dado diretamente.
 */
export const requestMeCorrectionSchema = z.object({
    field: z.string().trim().min(1).max(60),
    currentValue: z.string().trim().max(500).nullable().optional(),
    requestedValue: z.string().trim().min(1).max(500),
    reason: z.string().trim().min(1).max(1000),
});
//# sourceMappingURL=request-me-correction.js.map